import { CSSProperties } from "react";
import { version } from "../../../package.json";
import { MButton } from "../elements/mbutton";

interface UserPanelProps {
  onLogout(): void;
  style?: CSSProperties;
}

export function UserPanel(props: UserPanelProps) {
  return (
    <div
      style={{
        width: "60%",
        minWidth: "min(200px, 100%)",
        margin: "0 auto",
        display: "grid",
        gap: 8,
        ...props.style,
      }}
    >
      <MButton
        type="ghost"
        style={{ width: "100%", fontWeight: 400, marginTop: 48 }}
        onClick={props.onLogout}
      >
        Log ud
      </MButton>
      <a
        href={window.location.href}
        title="Opdater appen"
        onClick={(event) => {
          event.preventDefault();
          window.location.reload();
        }}
        style={{
          marginTop: 64,
          justifySelf: "center",
          padding: "4px 10px",
          borderRadius: 50,
          background: "#e5e7eb",
          color: "#6b7280",
          fontFamily: "inherit",
          fontSize: 12,
          textAlign: "center",
          textDecoration: "none",
          cursor: "pointer",
          WebkitTapHighlightColor: "transparent",
        }}
      >
        v{version}
      </a>
    </div>
  );
}
